module.exports = __webpack_public_path__ + "img/tip_icon.ac986441.png";